import { Injectable } from '@angular/core';
import { ApiService } from './api.service';

@Injectable({
	providedIn: 'root'
})
export class StoreService {

	constructor(private api: ApiService) { }

	all() {
		return this.api.get("store/all", { id: this.api.MERCHANT_ID });
	}

	one(id: string) {
		return this.api.get("store/one", { id: id });
	}
}
